module.exports = (fox) => {
  const $ = fox.jQuery;
  const AutoLoginService = require("../../auto-login")(fox);
  const _ = require("./mixins/constants");
  const configure = require("./mixins/translatorConfigure")(fox, _);
  const callbacks = require("./mixins/translatorCallbacks")(fox, _);
  const chatMethods = require("./mixins/translatorChatMethods")(fox, _);
  const billingMethods = require("./mixins/translatorBillingMethods")(fox, _);
  const isAllowedMethod = require("./mixins/isAllowed")(fox);

  fox.registerWidget(
    "ClientLSTranslator",
    fox.mixin(
      {
        _prepareWebrtcTranslation: function (params) {
          return new fox.Promise((resolve) => {
            this._prepareWebrtcTranslationResolve = resolve;
            this.sendMessageToModel({
              text: this.getPrepareWebrtcTranslationToken(),
              dataset: params,
            });
          });
        },

        running() {
          this.autoLoginService = new AutoLoginService(this);
          this.settings = {};
          this._chatConnectionStates = {};
          this._prepareWebrtcTranslationResolve = null;

          this.los = new fox.LocalStorageObjectService({
            lsLabel: "_lstrhs_",
            cleanCheckInterval: 1000 * 60 * 60 * 24,
          });

          const forceWebrtc = !fox.isEmpty(
            localStorage.getItem("_forcewebrtc_")
          );
          this.controller = this.createController(forceWebrtc, false, {
            onEvent: this._onEvent.bind(this),
            onError: this.onError.bind(this),
            debug: true /* __DEV__ */,
          });

          this.callParent("running", arguments);
        },

        prepareEmbeddedWidgets() {
          this._bindData = {
            status: null,
            showJoinBtn: false,
            showInProgressData: false,
            showPrivateBtn: false,
            isAllowedThis: false,
            isAllowedSidebar: false,
            thumbnail: "",
            defThumbnail: require("../images/in-progress.png"),
            bannedImage: require("../images/banned.png"),
            isRequester: false,
            allowedGroups: false,
            showTips: false,
          };

          this.bindTemplateVariables(
            this._bindData,
            [
              "isAllowedThis",
              "showJoinBtn",
              "showInProgressData",
              "showPrivateBtn",
              "showTips",
            ],
            ["isAllowed"]
          );
          this.rwom1("#status").bindTemplateVariables(this._bindData, [
            "status",
            "thumbnail",
            "isRequester",
            "defThumbnail",
            "bannedImage",
            "allowedGroups",
          ]);
          this.rwom1("#sidebarMain").bindTemplateVariables(
            this._bindData,
            ["isAllowedSidebar", "showTips"],
            ["isAllowed"]
          );

          this.callParent("prepareEmbeddedWidgets", arguments);
        },

        beforeRender() {
          this.setTemplateOptions("private", !!this.connectParams.private);

          this.callParent("beforeRender", arguments);
        },

        toggleGoPrivateBtn(disabled) {
          if (!this.rwom1("#privateControl").isEmbedded()) return false;

          return this.toggleButton(
            this.connectParams.private ? "#paid-leave" : "#paid-request",
            !!disabled
          );
        },

        setConnectParams(params) {
          this.callParent("setConnectParams", arguments);

          if (params.streamName)
            this.connectParams.streamName = params.streamName;

          if (params.stunServer)
            this.connectParams.stunServer = params.stunServer;

          if (params.paid) this.connectParams.paid = params.paid;

          if (params.private) this.connectParams.private = params.private;

          if (params.trustedHash)
            this.connectParams.trustedHash = params.trustedHash;

          if (params.host) this.connectParams.server = params.host;

          if (params.channelName)
            this.connectParams.channelName = params.channelName;

          if (params.token) this.connectParams.token = params.token;

          if (params.uid) this.connectParams.uid = params.uid;

          if (params.appId) this.connectParams.appId = params.appId;

          return this;
        },

        getConnectParams() {
          const params = this.callParent("getConnectParams", arguments);
          const pm = this.rwom1("@root #permissionManager");

          if (pm.hasAccess("free") || pm.hasAccess("member"))
            params.viewerId = this.getMemberInfo("id");

          return params;
        },

        initApp() {
          if (this.callParent("initApp", arguments) !== false) {
            const $container = $(this.controller._view).parent();

            this.setOption("flashWidth", $container.width());
            this.setOption("flashHeight", $container.height());
          }
        },

        manageStatusBanners(banner, force = false) {
          if (this._bindData.status === "banned" && !force) return false;

          this._bindData.status = banner;
        },

        checkTrustedHash() {
          if (this.connectParams.trustedHash)
            return (
              fox.objectGet(
                this.los.getItem(this.connectParams.trustedHash),
                "value"
              ) === this.getChatUserId()
            );

          return false;
        },

        _getEventCallbacks() {
          return [
            "stream_viewer_play_started",
            "stream_viewer_play_stopped",
            "stream_viewer_metadata",
          ];
        },

        entryAccessGranted(btn) {
          $(btn).toggleClass(_.DOM_CLASS_SPIN);

          return this.checkPayer({ rateId: this.settings.rateId }, $(btn))
            .then(() => {
              const entry = this.rwom1("#paidEntry");

              entry.deactivate();
              entry.removeFromDom();

              return this.startPlay();
            })
            .catch((resp) => {
              this.treatError({ id: resp.params.answer.code });
            });
        },

        startPlay() {
          const connectParams = this.getConnectParams();

          this.manageStatusBanners("loading");
          this._log(
            "Manage Status banners loading",
            this.manageStatusBanners("loading")
          );
          this.switchTabs("chat");

          const notificationList = document.querySelector("#notificationList");
          if (notificationList) {
            notificationList.classList.add("_hidden");
          }

          const valentinesPopup = document.querySelector(
            ".valentines-gift-popup"
          );
          if (valentinesPopup) {
            valentinesPopup.classList.add("_hidden");
          }

          const chatWrapper = document.querySelector(
            ".througth-chat-widget-wrapper"
          );
          if (chatWrapper) {
            chatWrapper.classList.add("_hidden");
          }

          return this.connectToChat().then(() => {
            this.controller.play({
              ...connectParams,
              prepareStreamCb: (...args) =>
                this._prepareWebrtcTranslation(...args),
            });
          });
        },

        volumeChange(el, alias, scope, event) {
          const $progress = $(this.dom1(".volume-progress"));
          const fw = $(el).width();
          const ds = Math.abs($(el).offset().left - event.clientX);
          const diff = parseInt((ds / fw) * 100);

          this.controller.setVolume(diff);
          this.setUiVolumeLevel(diff);
        },

        setUiVolumeLevel(level) {
          const $level = $(this.dom1(".volume-progress"));

          fox.utils.localStorage("setItem", "_lsvl_", level);

          $level.width(level + "%");

          if (level === 0) {
            $level.parents(".ls-btn").addClass("muted");
          } else {
            $level.parents(".ls-btn").removeClass("muted");
          }
        },

        toggleFullscreen(btn) {
          function getNotificationViewer() {
            return fox.wom
              .select("~.NotificationViewer")
              .filter(function (w) {
                return w.isActive() === true;
              })
              .pop();
          }

          var $btn = $(btn),
            $c = $(this.dom1(".brc-wrapper")),
            ntfv = getNotificationViewer(),
            cl = this.rwom1("#sidebarMain #tabChat"),
            chat = fox.site.wom1("#throughChatWindow");
          if (this.fullscreen === false) {
            this.setFullscreen();

            if (ntfv) {
              ntfv.deleteAll();
            }

            if (chat && chat.isEmbedded()) {
              $(chat.element).hide();
            }
          } else {
            this.exitFullscreen();
            if (chat && chat.isEmbedded()) {
              $(chat.element).show();
            }
          }

          $btn.toggleClass("exit-f");
          $c.toggleClass("brc-fullscreen");

          if (cl.isActive()) {
            cl.updateScrollbar();
          }

          if (this.streamInfo !== undefined) {
            this.setFlashSize(this.streamInfo);
          }
        },

        switchTabs(alias) {
          const sidebar = this.rwom1("#sidebarMain");
          const fullAlias = `tab${fox.ucfirst(alias)}`;

          if (!sidebar.isActive()) {
            this.wait(sidebar, "addedToDom").then(() => this.switchTabs(alias));
            return this.switchEmbeddedWidget("sidebarMain");
          }

          sidebar.switchEmbeddedWidget(fullAlias);
        },

        _onPaidSuccessfully() {
          const $c = $(this.dom1(".control-center"));

          $c.addClass(_.DOM_CLASS_TIPSUCCESS);

          setTimeout(() => {
            $c.removeClass(_.DOM_CLASS_TIPSUCCESS);
          }, _.TIMER_THANKYOU);
        },

        toggleGiftBox(el, alias) {
          function getBtn() {
            return $(this.dom1(_.DOM_SELECTOR_SENDGIFTBTN));
          }

          var gb = this.rwom1("#giftBox");

          if (!gb.isActive()) {
            if (alias !== "giftPaidSuccess") {
              this.switchEmbeddedWidget("giftBox");
            }
          } else {
            this.switchEmbeddedWidget("sidebarMain");
            this.updateFansAmount(false, this.rwom1(".Widget #tabFans"));
          }

          if (alias === "giftPaidSuccess") {
            this._onPaidSuccessfully();
          }
        },

        updateFansAmount(params, performer) {
          function setAmount(a, performer) {
            var $c = $(performer.dom1(".ls-tab-counter"));

            $c.text(a);
          }

          const amount = performer.getUsersAmount();

          if (performer.getParent().isEmbedded()) {
            setAmount(amount, performer.getParent());
          } else {
            performer
              .getParent()
              .wait("addedToDom")
              .then(function (resp) {
                setAmount(amount, resp.performer);
              });
          }
        },

        giftSended() {
          this.toggleGiftBox(this.dom1("#toggle-gift-box"));
        },

        getFullscreenMargins() {
          return _.fm;
        },

        setStreamInfo(info) {
          this.streamInfo = {
            w: info.width,
            h: info.height,
          };

          return this.streamInfo;
        },

        _resetStates() {
          const sm = this.rwom1("#sidebarMain");
          const pe = this.rwom1("#paidEntry");
          const er = this.rwom1("#error");

          sm.rwom1("#tabChat").reset();
          sm.rwom1("#tabFans").reset();
          this.manageStatusBanners(false);
          this.togglePrivateControl(3);

          if (pe.isEmbedded()) pe.removeFromDom();

          if (er.isEmbedded()) er.removeFromDom();

          pe.deactivate();
          er.deactivate();

          if (sm.templateOptions.hideFans) {
            delete sm.templateOptions.hideFans;
            sm.rwom1("#tabs").setOption("switchOnEmbed", true);
          }
        },

        deactivate() {
          this.__privateRequestTimer = null;
          this.leaveLiveshow(true).cleanConnectParams()._resetStates();
          const notificationList = document.querySelector("#notificationList");
          if (notificationList) {
            notificationList.classList.remove("_hidden");
          }

          const valentinesPopup = document.querySelector(
            ".valentines-gift-popup"
          );
          if (valentinesPopup) {
            valentinesPopup.classList.remove("_hidden");
          }

          const chatWrapper = document.querySelector(
            ".througth-chat-widget-wrapper"
          );
          if (chatWrapper) {
            chatWrapper.classList.remove("_hidden");
          }
          this.callParent("deactivate", arguments);
        },

        cleanConnectParams() {
          delete this.connectParams.private;
          delete this.connectParams.paid;
          delete this.connectParams.trustedHash;

          return this;
        },

        sendToUser(user) {
          const $textArea = $(this.rwom1("#sidebarMain").dom1("#message-body"));
          const text = "@" + user.name + ": ";

          $textArea.val(text).focus();
        },

        treatError() {
          const errorId = this.callParent("treatError", arguments);
          const w = this.rwom1("#error");

          w.setTemplateOptions("code", errorId);

          this.leaveChat();

          if (w.isActive()) return w.render();

          return this.switchEmbeddedWidget("error");
        },

        render(forceRender) {
          if (this.isEmbedded() || forceRender === true) {
            delete this.inst;

            this._resetStates();
          }

          this.callParent("render", arguments);
        },

        setLiveshowSettings(settings = {}) {
          if (settings.answer) settings = settings.answer;

          const privateShow = this.connectParams.private;

          this.settings = { ...this.settings, ...settings };
          this.rwom1(".ClientLSGoal").setGoal(settings.goal);
          this.toggleFans(
            parseInt(settings.showFanList) === 0 || privateShow ? false : true
          );
          this.togglePrivateControl(
            /*this.connectParams.paid || */ privateShow ? 2 : 1
          );

          const allowed = this.isAllowed();
          this._bindData.isAllowedSidebar = this._bindData.isAllowedThis =
            allowed;
          this._bindData.showJoinBtn =
            !allowed &&
            !this.rwom1("@root #permissionManager").hasAccess("member") &&
            this._bindData.status !== "done";
          this._bindData.showInProgressData =
            !allowed && this._bindData.status !== "done";
          this._bindData.showPrivateBtn =
            !allowed &&
            !privateShow &&
            this._bindData.status !== "done" &&
            this.settings.privateShowRequest == 1;
          this._bindData.thumbnail = this.settings.thumbnail || "";
          let allowedGroups = this.settings.allowedGroups;
          this._bindData.allowedGroups = allowedGroups.filter(
            (allowedGroups) => allowedGroups.length > 0
          ).length;

          return this;
        },

        togglePrivateControl(state) {
          var w = this.rwom1("#privateControl");
          var showRequest =
            fox.getEnv("public.ppmEnabled") &&
            /*(this.settings.paidShowRequest == 1) ||*/ this.settings
              .privateShowRequest == 1;
          var showLeave =
            fox.getEnv("public.ppmEnabled") && this.connectParams.private;

          function reset() {
            w.setTemplateOptions({});

            if (w.isEmbedded()) {
              w.deactivate();
              w.removeFromDom();
            }
          }

          switch (state) {
            case 3:
              reset();
              break;
            case 1:
              if (showRequest) {
                w.setTemplateOptions("state", state);
              } else {
                reset();
              }

              break;
            case 2:
              if (showLeave) {
                w.setTemplateOptions("state", state);
              }

              break;
          }

          if (w.isEmbedded()) {
            var btnState = $(
              w.dom1(
                this.connectParams.private ? "#paid-leave" : "#paid-request"
              )
            ).prop("disabled");

            w.wait("addedToDom").then(
              function () {
                this.toggleGoPrivateBtn(btnState);
              }.bind(this)
            );
          }

          if (!w.isActive()) {
            w.activate();
          } else {
            w.render();
          }
        },

        toggleFans(show) {
          const sm = this.rwom1("#sidebarMain");

          if (show === true) {
            if (sm.templateOptions.hideFans === true) {
              delete sm.templateOptions.hideFans;

              if (sm.isActive()) {
                sm.render();
              }

              this.updateFansAmount(false, sm.rwom1("#tabFans"));
            }

            return true;
          }

          sm.setTemplateOptions("hideFans", true);
          sm.rwom1("#tabs").setOption("switchOnEmbed", false);

          if (sm.rwom1("#tabFans").isActive()) {
            this.switchTabs("chat");

            sm.render();
          } else if (sm.isActive()) {
            sm.render();
          } else if (sm._reactivationPool.indexOf("tabFans") !== -1) {
            sm._reactivationPool.splice(
              sm._reactivationPool.indexOf("tabFans"),
              1,
              "tabChat"
            );
          }
        },

        toggleButton(selector, disabled = false) {
          const btn = this.dom1(selector);

          if (btn && btn.tagName.toLowerCase() === "button")
            return (btn.disabled = disabled);

          const $btn = $(btn);
          $btn[disabled ? "addClass" : "removeClass"]("disabled");
        },

        errorIsActive() {
          return this.rwom1("#error").isActive();
        },

        toggleBtnLoader(btn) {
          const $btn = $(btn);

          if ($btn.hasClass(_.DOM_CLASS_SPIN)) {
            $btn.removeClass(_.DOM_CLASS_SPIN);
            if ($btn.is("button")) $btn.prop("disabled", false);
          } else {
            $(btn).addClass(_.DOM_CLASS_SPIN);
            if ($btn.is("button")) $btn.prop("disabled", true);
          }
        },

        leaveLiveshow(skipFlashDisconnect, skipPlayStop) {
          if (skipFlashDisconnect !== true) {
            this.manualDisconnect = true;

            this.controller.stop();

            if (!skipPlayStop) this.stream_viewer_play_stopped();

            this.sendMessageToModel({ text: this.getLeavePrivateToken() });
          }

          this.leaveChat();

          return this;
        },

        isDisconnected() {
          return this.status === _.STATUS_DISCONNECTED;
        },

        getMemberInfo(field) {
          const result = this.wom1("@root #permissionManager").getMemberInfo(
            field
          );
          const chatctrl = this.rwom1("@root #uchatctrl");

          if (fox.isEmpty(result)) {
            const obj = {
              id: chatctrl.userId,
              login: chatctrl.userId.replace(/^guest_/, "Guest "),
            };

            if (field === "id") return obj.id;

            if (field === "login") return obj.login;

            return obj;
          }

          return result;
        },

        showPaidConfirm() {
          const api = this.getApi("rateList", { method: "liveshow.ratesList" });
          const psc = this.rwom1("#paidShowConfirmBody");

          if (psc.templateOptions.rates) {
            psc.setTemplateOptions("state", 2);
            this.switchEmbeddedWidget("paidShowConfirmBody");
            return psc.wait("addedToDom");
          }

          psc.setTemplateOptions("state", 1);

          this.switchEmbeddedWidget("paidShowConfirmBody");

          return api.psend({}).then((resp) => {
            const showPrivate =
              parseInt(this.settings.privateShowRequest) === 1 &&
              !this.connectParams.private;
            const showPaid = false; //parseInt(this.settings.privateShowRequest) === 1 && !this.connectParams.paid;

            const rates = resp.params.answer.response
              .filter((v) => {
                const res =
                  v.typeAlias === "private"
                    ? showPrivate
                    : v.typeAlias === "public"
                    ? showPaid
                    : true;

                return v.primary === 1 && res;
              })
              .filter((v) => v.typeAlias === "private");

            const promise = psc.wait("addedToDom");

            psc
              .setTemplateOptions({
                state: 2,
                rates: rates,
              })
              .render();

            return promise;
          });
        },

        privateShowConfirmed(el, alias, performer) {
          const pm = this.rwom1("@root #permissionManager");
          const [requestType, requestPrice, requestRateId] = $(
            performer.dom1('[name="paidShowType"]:checked')
          )
            .val()
            .split(":");
          const params = {
            requestType,
            requestPrice,
            requestRateId,
            btn: el,
          };

          if (params.requestType === "public") params.requestType = "paid";

          const isGuestUser = pm.hasAccess("guestActual");

          if (params.requestType) {
            let prepareUserPromise = fox.Promise.resolve([true]);

            if (isGuestUser) prepareUserPromise = this.showGuestPopup();

            return prepareUserPromise
              .then(([result]) => {
                if (!result) return [false];

                this._log("sendPaidShowRequest");
                return this.sendPaidShowRequest({ ...params, ...result });
              })
              .then(([result, success]) => {
                if (result === true) {
                  this._log("privateShowConfirmed success");
                  this.toggleGoPrivateBtn(true);

                  this.__privateRequestTimer = setTimeout(() => {
                    this.__privateRequestTimer = null;

                    if (this.rwom1("#privateControl").isEmbedded())
                      this.toggleGoPrivateBtn();
                  }, 150 * 1000);

                  return success.then(() => {
                    if (!isGuestUser) return result;

                    this._log("renewing connect params");
                    this.controller.release();
                    return this.getParent().checkLiveShows();
                  });
                }
              });
          }

          this.switchEmbeddedWidget("sidebarMain");
        },

        showGuestPopup() {
          let popup = this.wom1("#guestPopup");

          if (!popup) {
            popup = this.embedWidget(
              "guestPopup",
              "Common_GuestPurchasePopup",
              {
                contentTemplate: "guest_private_request_popup_content",
              }
            );

            popup.run();
          }

          this._log("showGuestPopup");
          return popup.show().then((result) => {
            if (result !== false) {
              return [
                this.autoLoginService.injectToken(
                  result.result,
                  new Date().getTime().toString()
                ),
              ];
            }

            return [result];
          });
        },

        _log(...args) {
          return console.log("[ClientLSTranslator]: -> ", ...args);
        },
      },
      configure,
      callbacks,
      chatMethods,
      billingMethods,
      isAllowedMethod
    ),
    "LSTranslator"
  );
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/ClientLSTranslator.es.js